export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mon brief quotidien"])},
        "adjust_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajuster l'objectif du mois"])},
        "sellers_ranking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement vendeurs"])},
        "network_ranking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement réseau"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My daily brief"])},
        "adjust_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjust monthly target"])},
        "sellers_ranking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sellers ranking"])},
        "network_ranking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network ranking"])}
      }
    }
  })
}
